module.exports = __webpack_public_path__ + "static/media/model5.ab855216.glb";